import { Box, styled, themeGet } from '@qwealth/qcore';

export const StyledClientNotesHistoryNoteCard = styled(Box)`
  background-color: ${themeGet('colors.gray.4')};
  border: none;
  filter: drop-shadow(4px 4px 2px rgba(0, 0, 0, 0.1));

  color: ${themeGet('colors.dark')};

  padding: ${themeGet('space.large')};
  border-radius: ${themeGet('radii.default')};
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.default')};
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${themeGet('colors.gray.3')};
    color: ${themeGet('colors.primaryLight.1')};
    transform: translateY(-1px);
  }
`;

export const StyledNotesHistoryClientSelectionCard = styled(Box)`
  background-color: ${themeGet('colors.gray.4')};
  color: ${themeGet('colors.dark')};
  padding: ${themeGet('space.default')};
  border-radius: ${themeGet('radii.default')};
  justify-content: space-between;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeGet('space.default')};

  &:hover {
    background-color: ${themeGet('colors.gray.2')};
    color: ${themeGet('colors.primaryLight.1')};
    cursor: pointer;
  }
`;

export const StyledChevronContainer = styled(Box)`
  &:hover {
    transform: translateX(5px);
    transition: transform 0.3s ease;
  }
`;

export const StyledClientNotesHistoryComplianceApprovedCard = styled(Box)`
  background-color: ${themeGet('colors.gray.4')};
  border: none;
  filter: drop-shadow(4px 4px 2px rgba(0, 0, 0, 0.1));

  color: ${themeGet('colors.dark')};

  padding: ${themeGet('space.large')};
  border-radius: ${themeGet('radii.default')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: ${themeGet('space.default')};

  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${themeGet('colors.gray.3')};
    color: ${themeGet('colors.primaryLight.1')};
    transform: translateY(-1px);
  }
`;
